export default function appointments(state = {data: [], tmpData: null}, action) {
    switch (action.type) {
        case 'ON_NEW_TOOTH_DATA':
            state = {
                data: state.data.concat(action.data),
                tmpData: null
            };

            break;
        case 'ON_UPDATED_TOOTH_DATA':
            state = {
                data: action.data,
                tmpData: null
            };

            break;
        case 'ON_UPDATED_TEMP_TOOTH_DATA':
            // if (! typeof state.tmpData[0] === 'undefined') {
            //     state.tmpData[0] = action.data;
            // }
            //
            // if (state.tmpData.length <= 0) {
            //     state.tmpData.push(action.data);
            // }

            state.tmpData = action.data;

            // console.log('updated_temp_tooth', state.tmpData);

            break;

        case 'ON_APPLY_TEMP_TOOTH_DATA':
            if (state.tmpData === null) {
                return state;
            }

            let newFills = [];
            let fills = [];
            for (let toothId of action.data) {
                let tmp = Object.assign({}, state.tmpData, {
                    tooth_id: toothId
                });

                // console.log('temporary', tmp);

                // find toothId
                let toothIndex = state.data.findIndex((item) => {
                    // eslint-disable-next-line
                    return item.tooth_id == toothId;
                });

                fills.push(tmp);
                if (toothIndex >= 0) {
                    state.data[toothIndex] = tmp;
                } else {
                    newFills.push(tmp);
                }
            }

            // console.log(newFills);

            // Save
            action.callback(fills);

            state = {
                data: state.data.concat(newFills),
                tmpData: null
            };

            // console.log('applied_temp_tooth_data', state.data);

            break;
        default:
            // Do nothing
    }

    return state;
}


/** WEBPACK FOOTER **
 ** ./src/reducers/charting.js
 **/